import { Pipe, PipeTransform } from '@angular/core';
import { transformRegionToReadableString } from '../services/transformRegionName';

@Pipe({ name: 'RegionTextTransformPipe' })
export class RegionTextTransformPipe implements PipeTransform {
  transform(value: string): string {
    return transformRegionToReadableString(value);
  }
}
